














import { ClientFilterI } from '@/interfaces/Filters';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
@Component({ name: 'ClientFilter' })
export default class ClientFilter extends Vue {
  @Prop() value: ClientFilterI;
  filter: string = '';
  search: string = '';
  loading: boolean = false;

  get clients(): ClientFilterI[] {
    return this.$store.getters.getClients;
  }

  @Watch('value')
  watchValueS(value: ClientFilterI) {
    if (!value.id) {
      this.filter = '';
      this.search = '';
    }
  }
}
